import { Component, type OnInit, type OnDestroy } from '@angular/core'
import { DialogService, type DynamicDialogRef } from 'primeng/dynamicdialog'
import { ChatWindowComponent } from './chat-window/chat-window.component'
import { type Subscription } from 'rxjs'
import { Router, NavigationEnd } from '@angular/router'

@Component({
  standalone: false,
  selector: 'app-chat-wrapper',
  templateUrl: './chat-wrapper.component.html',
  styleUrls: ['./chat-wrapper.component.scss']
})
export class ChatWrapperComponent implements OnInit, OnDestroy {
  ref: DynamicDialogRef
  routerSubscription: Subscription
  constructor (public dialogService: DialogService, private readonly router: Router) {}

  ngOnInit () {
    this.ref = this.dialogService.open(ChatWindowComponent, {
      closable: false,
      showHeader: false,
      modal: false,
      width: '150px',
      styleClass: 'chat-wrapper unique-chat-modal',
      style: {
        'align-self': 'flex-start',
        'margin-left': 'auto',
        'margin-top': 'auto',
        'margin-bottom': '10px',
        'margin-right': '10px',
        'max-height': '500px'
      }
    })

    // Subscribe to router events
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const allowedPaths = ['/size-intelligence-modules-dashboard']

        // Check if the current path is not allowed
        if (!allowedPaths.includes(this.router.url)) {
          this.ref.close() // Close the modal
        }
      }
    })
  }

  ngOnDestroy () {
    // Clean up subscriptions and close the modal if it's still open
    if (this.ref) {
      this.ref.close()
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe()
    }
  }
}
